import React, { useEffect, useContext, useState } from "react";
import ApplicationContext from "../../../context/index";
import CallToAction from "../partials/cta";
import CircularProgress from "@mui/material/CircularProgress";
import SectionTitle from "../../../components/sectionTitle";
import { Backdrop, Box, Typography } from "@mui/material";
import { getRoute } from "../../../helpers/utils";
import { useHistory } from "react-router";
import { getStorageItem, setStorageItem } from "../../../helpers/utils";
import { postWebService } from "../../../helpers/server";
import { buildWrapperTokenHeader } from "../../../helpers/lead";
import { useStyles } from "../indexFormStyles";
import { withStyles } from "@mui/styles";

function BuyflowPaymentFailed({
  classes: { containerButton, main, loaderBox },
}) {
  const { state, dispatch } = useContext(ApplicationContext);
  const history = useHistory();
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [isLoaded, setIsLoaded] = useState(true);
  const [message, setMessage] = useState(
    "Payment in being processed. Please do not refresh the page or use the back button."
  );
  const [patmentStatus, setPaymentStatus] = useState(0);
  const [backdrop, setBackdrop] = useState(true);

  useEffect(() => {
    const cbSuccessWrapperToken = ({ access_token }) => {
      setStorageItem("access-token", access_token);

      let transactionData = getStorageItem("transactiondata");
      transactionData = JSON.parse(transactionData);

      transactionData?.terminal_state === "Y"
        ? getPaymentResult(transactionData)
        : setPaymentStatus(0);
    };

    async function wrapperToken() {
      try {
        const header = buildWrapperTokenHeader();
        const response = await postWebService("token.php", {}, header);

        cbSuccessWrapperToken(response.data);
      } catch (error) {
        // console.log(error);
      }
    }

    wrapperToken();
  }, []);

  const cbError = (error) => {
    setIsFormSubmitted(false);
    setBackdrop(false);
  };

  const cbSuccessPaymentResult = ({ code }) => {
    if (code == 200) {
      generatePaymentReceipt();
    } else if (code == 403) {
      setBackdrop(false);
      navigateTo(getRoute("paymentFailed"));
    } else if (code == 400) {
      setMessage(
        "Your payment is pending. Please wait while we receive confirmation from BillDesk."
      );
    }
  };

  const getPaymentResult = async (transactionData) => {
    try {
      setPaymentStatus(1);
      const response = await postWebService(
        "payment-result.php",
        transactionData
      );

      cbSuccessPaymentResult(response.data);
    } catch (error) {
      cbError(error);
    }
  };

  const generatePaymentReceipt = async () => {
    try {
      const response = await postWebService("paymentconfirmation.php", {
        oid: Number(localStorage.getItem("oid")),
      });

      setBackdrop(false);
      navigateTo(getRoute("instaConfirmation"));
    } catch (error) {
      cbError(error);
    }
  };

  const navigateTo = (pathname) => history.push({ pathname });

  return isLoaded ? (
    <Box className={main}>
      <Box display="flex" justifyContent="center" ml={0} mr={0} mt={3} mb={3}>
        <SectionTitle title={"Payment Acknowledgement"} />
      </Box>

      <Box className={main}>
        <Box>
          <Typography variant="caption">{message}</Typography>
        </Box>
      </Box>

      <Backdrop sx={{ color: "#fff", zIndex: 1301 }} open={backdrop}>
        <Box
          flexDirection="column"
          display="flex"
          justifyContent="center"
          sx={{ width: "100%" }}
          textAlign="center"
        >
          <Typography variant="body1">{message}</Typography>
          <Box mt={2}>
            <CircularProgress color="inherit" />
          </Box>
        </Box>
      </Backdrop>
    </Box>
  ) : (
    <Box className={loaderBox}>
      <CircularProgress color={"secondary"} />
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(BuyflowPaymentFailed);
